import { render } from "./sidebar-context.vue?vue&type=template&id=ff0ffc56&lang=pug"
import script from "./sidebar-context.vue?vue&type=script&lang=js"
export * from "./sidebar-context.vue?vue&type=script&lang=js"

import "./sidebar-context.vue?vue&type=style&index=0&id=ff0ffc56&lang=scss"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.17_webpack@5.97.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"packages/client/src/core-components/sidebar/sidebar-context.vue"]])

export default __exports__